import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, Route, RouteComponentProps, Switch, useRouteMatch } from 'react-router-dom';
import appState from '../../state/AppStateContainer';
import {
  fromOf,
  lastEvaluationsUrl,
  supplierEvaluationsUrl,
} from '../../util/evaluationsNavigation';
import { EvaluationsOverview } from '../app-evaluation-overview';
import { EvaluationWizard } from '../app-evaluation-wizard';
import EvaluationsLayout from './EvaluationsLayout';
import RequestStatusPage from './RequestStatusPage';

export const PageSupplierEvaluations: FC = () => {
  const [t] = useTranslation('evaluations');
  const { path, url } = useRouteMatch();

  // One element tree for both views, so a view switch updates the overview instead of remounting it
  const renderOverview = (view: 'project' | 'supplier') => (
    <EvaluationsLayout view="overview">
      <EvaluationsOverview view={view} />
    </EvaluationsLayout>
  );

  return (
    <Switch>
      <Route
        exact
        path={`${path}/requests/:requestId`}
        render={({ match }: RouteComponentProps<{ requestId: string }>) => (
          <RequestStatusPage key={match.params.requestId} requestId={match.params.requestId} />
        )}
      />
      {/* Older links to a supplier's utvärderingar. */}
      <Route
        exact
        path={`${path}/suppliers/:supplierId`}
        render={({ match }: RouteComponentProps<{ supplierId: string }>) => (
          <Redirect to={supplierEvaluationsUrl(match.params.supplierId)} />
        )}
      />
      <Route exact path={`${path}/by-supplier`} render={() => renderOverview('supplier')} />
      <Route
        exact
        path={`${path}/new`}
        render={({ location }) =>
          appState.isWriteAccessRole() ? (
            <EvaluationsLayout
              view="new"
              path={[
                t('overview.breadcrumb', 'Utvärderingar'),
                t('register.newEvaluation', 'Ny utvärdering'),
              ]}
              backTo={fromOf(location.state) ?? lastEvaluationsUrl()}
            >
              <EvaluationWizard />
            </EvaluationsLayout>
          ) : (
            <Redirect to={url} />
          )
        }
      />
      <Route exact path={path} render={() => renderOverview('project')} />
      <Redirect to={url} />
    </Switch>
  );
};
